/* SMIRO shop filters (2026-10-07, index layout 2026-10-13). Pairs with sections/smiro-shop-filters.liquid.
   The desktop index is rendered inside the section and moved into the product grid's .smiro-sidebar slot
   (so it sits beside the rings); clicks and region patches cover both places.
   State = the URL's Shopify filter params. A tap builds the next params, asks Shopify to render this
   section and the product grid with them (Section Rendering API), swaps the marked regions in place
   and pushes the URL. The mobile sheet works on a pending copy and previews the count before "Show". */
(function () {
  var root = document.querySelector('[data-sf]');
  if (!root || root.__sf) return;
  root.__sf = true;

  var sid = root.getAttribute('data-section');
  var noun = root.getAttribute('data-noun') || 'rings';
  var gridSection = document.getElementById('ProductGridContainer');
  gridSection = gridSection && gridSection.closest('.shopify-section');
  var gid = gridSection ? gridSection.id.replace(/^shopify-section-/, '') : null;
  var sheet = root.querySelector('[data-sf-sheet]');
  var back = root.querySelector('[data-sf-back]');
  var bar = root.querySelector('[data-sf-bar]');
  var openBtn = root.querySelector('[data-sf-open]');
  var slot = null;
  function mine(n) { return !!n && (root.contains(n) || (slot && slot.contains(n))); }

  var state = clean(new URLSearchParams(location.search));
  var pending = null;
  var ctrl = null, previewCtrl = null, sheetSnapshot = '', showSnapshot = '';

  function clean(p) { p.delete('page'); p.delete('section_id'); p.delete('sections'); return p; }
  function copy(p) { return new URLSearchParams(p.toString()); }
  function urlFor(p) { var q = p.toString(); return location.pathname + (q ? '?' + q : ''); }

  function toggle(p, k, v) {
    var all = p.getAll(k), had = all.indexOf(v) > -1;
    p.delete(k);
    all.forEach(function (x) { if (x !== v) p.append(k, x); });
    if (!had) p.append(k, v);
  }
  function setPrice(p, keys, lo, hi) {
    var kk = keys.split('|'), gte = kk[0], lte = kk[1];
    var same = (p.get(gte) || '') === (+lo > 0 ? String(lo) : '') && (p.get(lte) || '') === (hi || '');
    p.delete(gte); p.delete(lte);
    if (!same) { if (+lo > 0) p.set(gte, lo); if (hi) p.set(lte, hi); }
  }
  function clearFilters(p) {
    Array.from(p.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0) p.delete(k); });
    return p;
  }

  function fetchSections(p, ids, signal) {
    var q = p.toString();
    return fetch(location.pathname + '?' + (q ? q + '&' : '') + 'sections=' + ids.join(','), { credentials: 'same-origin', signal: signal })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function parse(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return d; }

  function focusKey(el) {
    if (!mine(el)) return null;
    if (el.hasAttribute('data-k')) return '[data-k="' + el.getAttribute('data-k') + '"][data-v="' + CSS.escape(el.getAttribute('data-v')) + '"]';
    if (el.hasAttribute('data-plo')) return '[data-plo="' + el.getAttribute('data-plo') + '"][data-phi="' + el.getAttribute('data-phi') + '"]';
    if (el.hasAttribute('data-sf-ddbtn')) { var dd = el.closest('[data-sf-dd]'); return '[data-sf-dd="' + dd.getAttribute('data-sf-dd') + '"] [data-sf-ddbtn]'; }
    return null;
  }
  function restoreFocus(sel, scope) {
    if (!sel) return;
    /* the section holds a hidden takeover copy of every chip, so the visible one in the slot comes first */
    var el = scope ? scope.querySelector(sel) : ((slot && slot.querySelector(sel)) || root.querySelector(sel));
    if (el) el.focus({ preventScroll: true });
  }

  function patch(doc, names) {
    names.forEach(function (n) {
      var cur = Array.prototype.filter.call(document.querySelectorAll('[data-sf-region="' + n + '"]'), mine);
      var nu = doc.querySelectorAll('[data-sf-region="' + n + '"]');
      cur.forEach(function (c, i) { if (nu[i]) c.innerHTML = nu[i].innerHTML; });
    });
  }
  function regionNames(doc) {
    var seen = {};
    doc.querySelectorAll('[data-sf-region]').forEach(function (r) { seen[r.getAttribute('data-sf-region')] = 1; });
    return Object.keys(seen);
  }


  /* Shopify drops a picked value from filter.values once it has zero matches (Engraved + Under $1,500).
     The bar's badge counts from the URL so it never reads 0 while something is picked. */
  var LABELS = {};
  try { LABELS = JSON.parse((root.querySelector('[data-sf-labels]') || {}).textContent || '{}'); } catch (e) { LABELS = {}; }
  function labelOf(v) { return LABELS[v] || v; }
  function el(tag, cls, attrs, text) {
    var n = document.createElement(tag); if (cls) n.className = cls;
    Object.keys(attrs || {}).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (text != null) n.textContent = text; return n;
  }
  function ensureActive() {
    var active = [];
    state.forEach(function (v, k) { if (k.indexOf('filter.') === 0 && k.indexOf('.price.') < 0) active.push([k, v]); });
    var priceOn = state.has('filter.v.price.gte') || state.has('filter.v.price.lte');
    /* a picked value with zero matches is missing from the render: put a pressed, removable chip back in its group */
    active.forEach(function (kv) {
      var sel = '[data-k="' + kv[0] + '"][data-v="' + CSS.escape(kv[1]) + '"]';
      var groups = Array.prototype.filter.call(document.querySelectorAll('.sf-chips'), function (g) { return mine(g) && g.querySelector('[data-k="' + kv[0] + '"]') && !g.querySelector(sel); });
      groups.forEach(function (g) {
        var a = el('a', 'sf-chip', { href: '#', role: 'button', rel: 'nofollow', 'data-k': kv[0], 'data-v': kv[1], 'aria-pressed': 'true', 'aria-label': labelOf(kv[1]) + ', 0 ' + noun });
        a.appendChild(el('span', '', {}, labelOf(kv[1]))); a.appendChild(el('i', '', {}, '0'));
        g.appendChild(a);
      });
    });
    var n0 = active.length + (priceOn ? 1 : 0);
    var cw = root.querySelector('[data-sf-region="clear"]');
    if (cw && n0 && !cw.querySelector('[data-sf-clearall]')) cw.appendChild(el('a', 'sf-clear', { href: location.pathname, rel: 'nofollow', 'data-sf-clearall': '' }, 'Clear'));
    if (cw && !n0) cw.innerHTML = '';
    root.querySelectorAll('[data-clear]').forEach(function (all) {
      var ks = all.getAttribute('data-clear').split(' '), k = ks[0], vals = state.getAll(k);
      if (ks.some(function (x) { return state.getAll(x).length; })) all.setAttribute('aria-pressed', 'false');
      if (!vals.length) return;
      all.setAttribute('aria-pressed', 'false');
      vals.forEach(function (v) {
        if (all.parentNode.querySelector('[data-k="' + k + '"][data-v="' + CSS.escape(v) + '"]')) return;
        var a = el('a', 'sf-pill', { href: '#', role: 'button', rel: 'nofollow', 'data-k': k, 'data-v': v, 'aria-pressed': 'true' });
        a.appendChild(el('span', '', {}, labelOf(v))); a.appendChild(el('i', '', {}, '0'));
        all.parentNode.insertBefore(a, all.nextSibling);
      });
    });
    root.querySelectorAll('.sf-rail-shape [data-k]').forEach(function (a) {
      if (state.getAll(a.getAttribute('data-k')).indexOf(a.getAttribute('data-v')) > -1) { a.setAttribute('aria-pressed', 'true'); a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
    });
    var n = active.length + (priceOn ? 1 : 0);
    root.querySelectorAll('[data-sf-region="badge"]').forEach(function (b) { b.textContent = n ? String(n) : ''; });
  }

  /* ---------------- apply = grid + every region */
  function apply(p, opts) {
    opts = opts || {};
    var grid = document.getElementById('ProductGridContainer');
    if (!gid || !grid) { location.href = urlFor(p); return; }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var openDd = root.querySelector('[data-sf-dd] [data-sf-pop]:not([hidden])');
    openDd = openDd && openDd.closest('[data-sf-dd]').getAttribute('data-sf-dd');
    var fk = focusKey(document.activeElement);
    grid.classList.add('sf-loading');
    root.setAttribute('aria-busy', 'true');
    return fetchSections(p, [sid, gid], ctrl.signal).then(function (data) {
      var g = parse(data[gid]).querySelector('#ProductGridContainer');
      grid = document.getElementById('ProductGridContainer');
      if (g && grid) grid.innerHTML = g.innerHTML;
      var s = parse(data[sid]);
      patch(s, regionNames(s).filter(function (n) { return opts.keepSheet ? n !== 'sheet' && n !== 'show' : true; }));
      state = copy(p);
      ensureActive();
      if (opts.push !== false) history.pushState({ sf: 1, searchParams: p.toString() }, '', urlFor(p));
      if (openDd) { var dd = root.querySelector('[data-sf-dd="' + openDd + '"]'); if (dd) setDd(dd, true); }
      restoreFocus(fk);
      if (opts.scroll) scrollToGrid();
      document.dispatchEvent(new CustomEvent('smiro:filters', { detail: { params: p.toString() } }));
    }).catch(function (e) {
      if (e.name !== 'AbortError') location.href = urlFor(p);
    }).finally(function () {
      var gg = document.getElementById('ProductGridContainer');
      if (gg) gg.classList.remove('sf-loading');
      root.removeAttribute('aria-busy');
    });
  }

  function scrollToGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    var barH = (bar ? bar.getBoundingClientRect().height : 0) + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ch-stick')) || 0);
    var top = grid.getBoundingClientRect().top;
    if (top < barH) window.scrollTo({ top: window.scrollY + top - barH - 8, behavior: 'smooth' });
  }

  /* ---------------- sheet (pending params, live count) */
  var sheetBody = sheet && sheet.querySelector('[data-sf-region="sheet"]');
  function preview() {
    if (previewCtrl) previewCtrl.abort();
    previewCtrl = new AbortController();
    var fk = focusKey(document.activeElement);
    var top = sheetBody.scrollTop;
    sheetBody.classList.add('is-busy');
    fetchSections(pending, [sid], previewCtrl.signal).then(function (data) {
      patch(parse(data[sid]), ['sheet', 'show']);
      sheetBody.scrollTop = top;
      restoreFocus(fk, sheet);
    }).catch(function () {}).finally(function () { sheetBody.classList.remove('is-busy'); });
  }
  function openSheet() {
    if (!sheet) return;
    pending = copy(state);
    sheetSnapshot = sheetBody.innerHTML;
    var sh = root.querySelector('[data-sf-show]'); showSnapshot = sh ? sh.innerHTML : '';
    back.hidden = false; sheet.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.body.classList.add('sf-lock');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    if (sheetBody) { sheetBody.setAttribute('tabindex', '-1'); sheetBody.focus({ preventScroll: true }); }
  }
  function closeSheet(applied) {
    root.classList.remove('is-open');
    document.body.classList.remove('sf-lock');
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus({ preventScroll: true }); }
    if (!applied && pending && pending.toString() !== state.toString()) {
      sheetBody.innerHTML = sheetSnapshot;
      var show = root.querySelector('[data-sf-show]'); if (show) show.innerHTML = showSnapshot;
    }
    pending = null;
    setTimeout(function () { if (!root.classList.contains('is-open')) { back.hidden = true; sheet.hidden = true; } }, 300);
  }

  /* ---------------- desktop dropdowns */
  function setDd(dd, open) {
    var btn = dd.querySelector('[data-sf-ddbtn]'), pop = dd.querySelector('[data-sf-pop]');
    if (!btn || !pop) return;
    pop.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeDds(except) {
    root.querySelectorAll('[data-sf-dd]').forEach(function (dd) { if (dd !== except) setDd(dd, false); });
  }

  /* ---------------- clicks */
  function onClick(e) {
    var t = e.target.closest('a, button');
    if (!mine(t)) return;
    var inSheet = sheet && sheet.contains(t);

    if (t.hasAttribute('data-sf-open')) { e.preventDefault(); openSheet(); return; }
    if (t.hasAttribute('data-sf-close')) { e.preventDefault(); closeSheet(false); return; }
    if (t.hasAttribute('data-sf-show')) { e.preventDefault(); var p0 = pending || state; closeSheet(true); apply(p0, { scroll: true }); return; }
    if (t.hasAttribute('data-sf-sheetclear')) { e.preventDefault(); pending = clearFilters(copy(pending || state)); preview(); return; }
    if (t.hasAttribute('data-sf-ddbtn')) {
      e.preventDefault();
      var dd = t.closest('[data-sf-dd]'), open = t.getAttribute('aria-expanded') !== 'true';
      closeDds(dd); setDd(dd, open); return;
    }
    if (t.hasAttribute('data-sf-clearall')) { e.preventDefault(); apply(clearFilters(copy(state)), { scroll: true }); return; }
    if (t.hasAttribute('data-clear')) { e.preventDefault(); var pc = copy(state); t.getAttribute('data-clear').split(' ').forEach(function (k) { pc.delete(k); }); apply(pc); return; }

    var target = inSheet ? pending : copy(state);
    if (!target) return;
    if (t.hasAttribute('data-k')) {
      if (t.disabled || t.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      e.preventDefault();
      toggle(target, t.getAttribute('data-k'), t.getAttribute('data-v'));
    } else if (t.hasAttribute('data-pk')) {
      e.preventDefault();
      if (t.hasAttribute('data-px')) { var kk = t.getAttribute('data-pk').split('|'); target.delete(kk[0]); target.delete(kk[1]); }
      else setPrice(target, t.getAttribute('data-pk'), t.getAttribute('data-plo'), t.getAttribute('data-phi'));
    } else return;

    if (inSheet) { pending = target; preview(); }
    else apply(target, { scroll: !!t.closest('[data-sf-region="pills"], [data-sf-pop]') || !!(slot && slot.contains(t)) });
  }
  root.addEventListener('click', onClick);

  /* ---------------- desktop index: move it beside the grid */
  var index = root.querySelector('[data-sf-index]');
  var host = document.querySelector('.smiro-grid-layout > .smiro-sidebar');
  var hasChips = !!(index && index.querySelector('.sf-chip'));
  if (index && host && hasChips) {
    slot = el('div', 'sf-slot', { 'data-sf-slot': '' });
    slot.appendChild(index);
    host.appendChild(slot);
    host.classList.add('sf-host');
    host.parentNode.classList.add('sf-has-index');
    root.classList.add('sf-moved');
    slot.addEventListener('click', onClick);
  } else if (host && !hasChips) {
    host.parentNode.classList.add('sf-empty');
  } else if (hasChips) {
    root.classList.add('sf-noslot');
  }

  var sort = root.querySelector('[data-sf-sort]');
  if (sort) sort.addEventListener('change', function () { var p = copy(state); p.set('sort_by', sort.value); apply(p, { scroll: true }); });

  /* ---------------- sort menu (2026-10-16): replaces the native select's OS popup.
     Phones: bottom sheet. Desktop: fixed panel placed under the button. The select stays for no-JS. */
  var sortBtn = root.querySelector('[data-sf-sortbtn]');
  var sortM = root.querySelector('[data-sf-sortm]');
  var sortBack = root.querySelector('[data-sf-sortback]');
  var sortTimer = null, sortIsOpen = false, sortLocked = false;
  var wideMq = window.matchMedia('(min-width: 768px)');
  function isWide() { return wideMq.matches; }
  function sortOpen() { return sortIsOpen; }
  function placeSort() {
    if (!sortM) return;
    if (!isWide()) { sortM.style.top = ''; sortM.style.left = ''; sortM.style.maxHeight = ''; return; }
    var r = sortBtn.getBoundingClientRect(), w = sortM.offsetWidth || 240, top = Math.round(r.bottom + 8);
    sortM.style.top = top + 'px';
    sortM.style.left = Math.round(Math.max(8, Math.min(r.right - w, window.innerWidth - w - 8))) + 'px';
    sortM.style.maxHeight = Math.max(120, window.innerHeight - top - 8) + 'px';
  }
  function markSort(o) {
    sortM.querySelectorAll('[data-sf-sortopt]').forEach(function (x) { x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
    var cur = root.querySelector('[data-sf-sortcur]'); if (cur) { cur.textContent = o ? o.textContent : ''; cur.parentNode.hidden = !o; }
  }
  function openSort() {
    clearTimeout(sortTimer);
    closeDds(null);
    sortIsOpen = true;
    sortM.hidden = false;
    sortBack.hidden = isWide(); /* desktop: no backdrop, an outside click closes and still goes through */
    placeSort();
    requestAnimationFrame(function () { if (sortIsOpen) root.classList.add('is-sorting'); });
    sortBtn.setAttribute('aria-expanded', 'true');
    if (!isWide() && !document.body.classList.contains('sf-lock')) { document.body.classList.add('sf-lock'); sortLocked = true; }
    var cur = sortM.querySelector('[aria-selected="true"]') || sortM.querySelector('[data-sf-sortopt]');
    if (cur) cur.focus({ preventScroll: true });
  }
  function closeSort(refocus) {
    if (!sortIsOpen) return;
    sortIsOpen = false;
    root.classList.remove('is-sorting');
    if (sortLocked) { document.body.classList.remove('sf-lock'); sortLocked = false; }
    sortBtn.setAttribute('aria-expanded', 'false');
    if (refocus || sortM.contains(document.activeElement)) sortBtn.focus({ preventScroll: true });
    sortTimer = setTimeout(function () { if (!sortIsOpen) { sortM.hidden = true; sortBack.hidden = true; } }, 280);
  }
  if (sort && sortBtn && sortM && sortBack && sortM.querySelector('[data-sf-sortopt]')) {
    var native = sort.closest('.sf-sort-native');
    if (native) native.hidden = true;
    sortBtn.hidden = false;
    sortBtn.addEventListener('click', function (e) { e.preventDefault(); if (sortIsOpen) closeSort(false); else openSort(); });
    sortBack.addEventListener('click', function () { closeSort(false); });
    document.addEventListener('click', function (e) {
      if (sortIsOpen && !sortM.contains(e.target) && !sortBtn.contains(e.target) && !sortBack.contains(e.target)) closeSort(false);
    });
    sortM.addEventListener('click', function (e) {
      if (e.target.closest('[data-sf-sortclose]')) { e.preventDefault(); closeSort(true); return; }
      var o = e.target.closest('[data-sf-sortopt]');
      if (!o) return;
      e.preventDefault();
      var v = o.getAttribute('data-sf-sortopt');
      var was = o.getAttribute('aria-selected') === 'true';
      markSort(o);
      closeSort(true);
      if (was) return;
      sort.value = v;
      var p = copy(state); p.set('sort_by', v); apply(p, { scroll: true });
    });
    sortM.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') { e.preventDefault(); closeSort(true); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
      var os = Array.prototype.slice.call(sortM.querySelectorAll('[data-sf-sortopt]'));
      if (!os.length) return;
      var i = os.indexOf(document.activeElement);
      i = e.key === 'Home' ? 0 : e.key === 'End' ? os.length - 1 : e.key === 'ArrowDown' ? Math.min(os.length - 1, i + 1) : Math.max(0, i - 1);
      e.preventDefault(); os[i].focus();
    });
    window.addEventListener('scroll', function () { if (sortIsOpen && isWide()) placeSort(); }, { passive: true });
    window.addEventListener('resize', function () { if (sortIsOpen) placeSort(); });
    /* iOS fires resize as its toolbar moves: close only when the layout actually switches */
    var onMq = function () { closeSort(false); };
    if (wideMq.addEventListener) wideMq.addEventListener('change', onMq); else if (wideMq.addListener) wideMq.addListener(onMq);
    /* back/forward can change sort_by without a click */
    window.addEventListener('popstate', function () {
      closeSort(false);
      var v = new URLSearchParams(location.search).get('sort_by') || sort.getAttribute('data-sf-sortdefault') || 'manual';
      var o = sortM.querySelector('[data-sf-sortopt="' + (window.CSS && CSS.escape ? CSS.escape(v) : v.replace(/["\\]/g, '')) + '"]');
      markSort(o);
      if (o) sort.value = v;
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sf-dd]')) closeDds(null);
    var c = e.target.closest('[data-sf-clearall]'); /* the no-results card lives in the grid section */
    if (c && !root.contains(c)) { e.preventDefault(); apply(clearFilters(copy(state)), { scroll: true }); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' && root.classList.contains('is-open') && sheet) {
      var f = Array.prototype.filter.call(sheet.querySelectorAll('a[href], button:not([disabled]), select, [tabindex="-1"]'), function (x) { return x.offsetParent !== null && x.getAttribute('aria-disabled') !== 'true'; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !sheet.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !sheet.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      return;
    }
    if (e.key !== 'Escape') return;
    if (root.classList.contains('is-sorting')) { closeSort(true); return; }
    if (root.classList.contains('is-open')) { closeSheet(false); return; }
    var open = root.querySelector('[data-sf-pop]:not([hidden])');
    if (open) { var dd = open.closest('[data-sf-dd]'); setDd(dd, false); var b = dd.querySelector('[data-sf-ddbtn]'); if (b) b.focus(); }
  });
  if (back) back.addEventListener('click', function () { closeSheet(false); });

  window.addEventListener('popstate', function () {
    var p = clean(new URLSearchParams(location.search));
    if (p.toString() === state.toString()) return;
    apply(p, { push: false });
  });

  /* The bar pins to the top while the grid is on screen. position:sticky cannot do this: the bar's
     parent is this section, which ends where the grid begins. */
  var ph = null, stuck = null;
  function pin(force) {
    if (!bar) return;
    if (!ph) { ph = document.createElement('div'); ph.className = 'sf-ph'; bar.parentNode.insertBefore(ph, bar); }
    var grid = document.getElementById('ProductGridContainer');
    var h = bar.offsetHeight;
    /* 2026-10-16 (CLS): the placeholder also holds the bar's top margin, which .is-fixed sets to 0; without it the
       grid jumped up by that margin (32px on phones) every time the bar pinned, and back when it unpinned. */
    if (force || ph.smMt == null) {
      /* measure in flow: on a resize while pinned (phone 32px, desktop 40px) the stored margin would be stale */
      var pinned = bar.classList.contains('is-fixed');
      if (pinned) bar.classList.remove('is-fixed');
      ph.smMt = parseFloat(getComputedStyle(bar).marginTop) || 0;
      if (pinned) bar.classList.add('is-fixed');
    }
    /* pins under the phone header when it is showing (--ch-stick, 0 otherwise) */
    var stick = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ch-stick')) || 0;
    var want = ph.getBoundingClientRect().top < stick && !!grid && grid.getBoundingClientRect().bottom > h + stick + 60;
    if (want === stuck && !force) { if (sortOpen()) placeSort(); return; }
    var was = stuck;
    stuck = want;
    ph.style.height = want ? (h + (ph.smMt || 0)) + 'px' : '0px';
    bar.classList.toggle('is-fixed', want);
    if (was === true && !want) closeDds(null);
    if (sortOpen()) placeSort();
  }
  window.addEventListener('scroll', function () { pin(false); }, { passive: true });
  window.addEventListener('resize', function () { pin(true); });
  document.addEventListener('smiro:filters', function () { pin(true); });
  document.addEventListener('smiro:stick', function () { pin(true); });
  pin(true);
  ensureActive();
})();

/* Chips are links with role=button (2026-10-13): Space toggles them like a button. */
document.addEventListener('keydown', function (e) {
  if (e.key !== ' ' && e.key !== 'Spacebar') return;
  var t = e.target && e.target.closest && e.target.closest('.sf-chip[role="button"]');
  if (!t) return;
  e.preventDefault();
  t.click();
});
